import React from "react";

const TipTapSkeleton: React.FC = () => {
  return (
    <div className="w-full animate-pulse rounded-2xl bg-white p-5 shadow lg:px-10 dark:bg-black">
      <div className="flex flex-row flex-wrap gap-2 py-10">
        <div className="dark:bg-cream-700 bg-cream-300 h-4 w-16 rounded"></div>
        <div className="dark:bg-cream-700 bg-cream-300 h-4 w-16 rounded"></div>
        <div className="dark:bg-cream-700 bg-cream-300 h-4 w-16 rounded"></div>
        <div className="dark:bg-cream-700 bg-cream-300 h-4 w-16 rounded"></div>
      </div>
      <div className="h-auto w-full rounded-xl">
        <div className="dark:bg-cream-700 bg-cream-300 my-2 h-6 rounded"></div>
        <div className="dark:bg-cream-700 bg-cream-300 my-2 h-4 w-3/4 rounded"></div>
        <ul className="text-cream-300 list-disc pl-5">
          <li>
            <div className="dark:bg-cream-700 bg-cream-300 my-2 h-4 w-1/2 rounded"></div>
          </li>
          <li>
            <div className="dark:bg-cream-700 bg-cream-300 my-2 h-4 w-1/3 rounded"></div>
          </li>
          <li>
            <div className="dark:bg-cream-700 bg-cream-300 my-2 h-4 w-1/4 rounded"></div>
          </li>
        </ul>
        <div className="dark:bg-cream-700 bg-cream-300 my-2 h-4 w-1/2 rounded"></div>
        <div className="dark:bg-cream-700 bg-cream-300 my-2 h-4 w-1/2 rounded"></div>
      </div>
    </div>
  );
};

export default TipTapSkeleton;
